import styled from 'styled-components';
import {dFlexColumn} from '../../../../../../globalVariables/GlobalFlex';
import {desktopMedia} from '../../../../../../globalVariables/GlobalVariables';

export const titleBlock = styled.div`
    ${dFlexColumn}
    gap: var(--space-sm);
    text-align: start;
    padding-inline-end: 44px; /* clears the absolutely-positioned header actions on mobile */
    ${desktopMedia}{
        padding-inline-end: 0;
    }
`;

export const title = styled.h2`
    margin: 0;
    font-size: 28px;
    font-weight: var(--font-weight-semibold);
    line-height: 1.2;
`;

export const subtitle = styled.div`
    font-size: 20px;
    font-weight: var(--font-weight-regular);
    line-height: 1.2;
    color: ${p => p.theme.isDarkMode ? 'rgba(255,255,255,0.7)' : 'var(--color-text-secondary)'};
    ${desktopMedia}{
        font-size: var(--font-size-body);
        line-height: 1.4;
    }
`;
